if (!customElements.get('card-flip')) {
  class CardFlip extends HTMLElement {
    constructor() {
      super();

      this.dotsWrappers = this.querySelectorAll('[data-dots-wrapper]');
      this.dotsWrapperComputed = window.getComputedStyle(this.dotsWrappers[0]);
    }

    connectedCallback() {
      this.setDotSize();
      this.createObservers();
      this.updateDots();
    }

    createObservers() {
      this.intersectionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            entry.target.classList.toggle('is-flipped', entry.isIntersecting);
          });
        },
        {
          threshold: 0.5,
          rootMargin: '-25% 0px -25% 0px',
        },
      );

      this.intersectionObserver.observe(this);

      this.resizeObserver = new ResizeObserver(this.updateDots.bind(this));
      this.resizeObserver.observe(this);
    }

    updateDots() {
      this.setDotSize();

      this.dotsWrappers.forEach((dotsWrapper) => {
        const startingDots = Array.from(dotsWrapper.children).slice(0, 6);

        const wrapperSize = Math.max(
          dotsWrapper.clientHeight,
          dotsWrapper.clientWidth,
        );
        const dotsCount = Math.floor(wrapperSize / this.dotSize);
        const currentDots = dotsWrapper.children.length;

        if (dotsCount > currentDots) {
          for (let i = currentDots; i < dotsCount; i++) {
            const clone = startingDots[i % startingDots.length].cloneNode(true);
            dotsWrapper.appendChild(clone);
          }
        } else if (dotsCount < currentDots) {
          for (let i = currentDots; i > dotsCount; i--) {
            dotsWrapper.removeChild(dotsWrapper.lastChild);
          }
        }
      });
    }

    setDotSize() {
      const dotWidth = this.dotsWrappers[0].children[0].offsetWidth;
      const dotsGap = +this.dotsWrapperComputed.columnGap.replace('px', '');

      this.dotSize = dotWidth + dotsGap;
    }
  }

  customElements.define('card-flip', CardFlip);
}
